import { useEffect, useState } from "react";
import useShareText from "app/game-over/useShareText";
import useGameData from "app/game-data/useGameData";
import MenuButton from "app/ui/MenuButton";
import cn from "app/util/classnames";
import mixpanel from "mixpanel-browser";

interface ShareButtonProps {
  className?: string;
}

function isMobileBrowser(): boolean {
  const userAgent = navigator.userAgent;

  return /iPhone|iPad|iPod|android|IOS/i.test(userAgent);
}

export default function ShareButton({ className }: ShareButtonProps) {
  const data = useGameData();
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const { copyToClipboard, isCopied, setCopied, navigatorShareText } =
    useShareText();

  useEffect(() => {
    setIsMobile(isMobileBrowser());
  }, []);

  function share() {
    mixpanel.track("share", {
      game_id: data?.id,
    });

    if (!isMobile) {
      copyToClipboard();
      return;
    }

    try {
      navigatorShareText();
    } catch {
      copyToClipboard();
    }
  }

  return (
    <div className={cn("relative", className)}>
      <MenuButton
        className="px-5 max-w-56 bg-blue-dark text-md rounded-sm"
        onClick={share}
      >
        Share Results
      </MenuButton>

      {isCopied && (
        <div
          className="animate-bubble-fade-out pointer-events-none absolute left-1/2 top-full z-10 w-max -translate-x-1/2 -translate-y-20 bg-white px-4 py-2 text-black text-sm font-medium shadow-sm"
          onAnimationEnd={() => setCopied(false)}
        >
          Copied to clipboard
        </div>
      )}
    </div>
  );
}
